var _rect, _path, _path2, _path3, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _rect2, _path4, _path5, _path6, _circle10, _circle11, _circle12, _circle13, _circle14, _circle15, _circle16, _circle17, _circle18, _rect3, _path7, _path8, _path9, _circle19, _circle20, _circle21, _circle22, _circle23, _circle24, _circle25, _circle26, _circle27;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDragItems(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 233,
    height: 175,
    viewBox: "0 0 233 175",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 47,
    width: 193,
    height: 23,
    rx: 2,
    fill: "#718095",
    fillOpacity: 0.49
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M103.648 56.2002H25.3395C23.0851 56.2002 23 57.1656 23 58.3564C23 59.5473 23.0851 60.5127 25.3395 60.5127H103.648C105.903 60.5127 106 59.5473 106 58.3564C106 57.1656 105.903 56.2002 103.648 56.2002Z",
    fill: "#F3F6F9",
    fillOpacity: 0.7
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33.6883 63.0996H23.3101C23.0113 63.0996 23 64.1294 23 65.3996C23 66.6699 23.0113 67.6996 23.3101 67.6996H33.6883C33.9871 67.6996 34 66.6699 34 65.3996C34 64.1294 33.9871 63.0996 33.6883 63.0996Z",
    fill: "#F3F6F9",
    fillOpacity: 0.7
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M68.6682 49.2998H24.3248C23.0482 49.2998 23 50.2652 23 51.4561C23 52.6469 23.0482 53.6123 24.3248 53.6123H68.6682C69.9448 53.6123 70 52.6469 70 51.4561C70 50.2652 69.9448 49.2998 68.6682 49.2998Z",
    fill: "#F3F6F9",
    fillOpacity: 0.7
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 198.5,
    cy: 55.5,
    r: 1.5,
    fill: "#F3F6F9",
    fillOpacity: 0.7
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 202.5,
    cy: 55.5,
    r: 1.5,
    fill: "#F3F6F9",
    fillOpacity: 0.7
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 206.5,
    cy: 55.5,
    r: 1.5,
    fill: "#F3F6F9",
    fillOpacity: 0.7
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 206.5,
    cy: 59.5,
    r: 1.5,
    fill: "#F3F6F9",
    fillOpacity: 0.7
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 206.5,
    cy: 63.5,
    r: 1.5,
    fill: "#F3F6F9",
    fillOpacity: 0.7
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 202.5,
    cy: 59.5,
    r: 1.5,
    fill: "#F3F6F9",
    fillOpacity: 0.7
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 202.5,
    cy: 63.5,
    r: 1.5,
    fill: "#F3F6F9",
    fillOpacity: 0.7
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 198.5,
    cy: 59.5,
    r: 1.5,
    fill: "#F3F6F9",
    fillOpacity: 0.7
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 198.5,
    cy: 63.5,
    r: 1.5,
    fill: "#F3F6F9",
    fillOpacity: 0.7
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 76,
    width: 193,
    height: 23,
    rx: 2,
    fill: "#718095",
    fillOpacity: 0.49
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M103.648 85.2012H25.3395C23.0851 85.2012 23 86.1666 23 87.3574C23 88.5483 23.0851 89.5137 25.3395 89.5137H103.648C105.903 89.5137 106 88.5483 106 87.3574C106 86.1666 105.903 85.2012 103.648 85.2012Z",
    fill: "#F3F6F9",
    fillOpacity: 0.7
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M33.6883 92.1016H23.3101C23.0113 92.1016 23 93.1313 23 94.4016C23 95.6718 23.0113 96.7016 23.3101 96.7016H33.6883C33.9871 96.7016 34 95.6718 34 94.4016C34 93.1313 33.9871 92.1016 33.6883 92.1016Z",
    fill: "#F3F6F9",
    fillOpacity: 0.7
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M68.6682 78.3008H24.3248C23.0482 78.3008 23 79.2662 23 80.457C23 81.6479 23.0482 82.6133 24.3248 82.6133H68.6682C69.9448 82.6133 70 81.6479 70 80.457C70 79.2662 69.9448 78.3008 68.6682 78.3008Z",
    fill: "#F3F6F9",
    fillOpacity: 0.7
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 198.5,
    cy: 84.5,
    r: 1.5,
    fill: "#F3F6F9",
    fillOpacity: 0.7
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 202.5,
    cy: 84.5,
    r: 1.5,
    fill: "#F3F6F9",
    fillOpacity: 0.7
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 206.5,
    cy: 84.5,
    r: 1.5,
    fill: "#F3F6F9",
    fillOpacity: 0.7
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 206.5,
    cy: 88.5,
    r: 1.5,
    fill: "#F3F6F9",
    fillOpacity: 0.7
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    cx: 206.5,
    cy: 92.5,
    r: 1.5,
    fill: "#F3F6F9",
    fillOpacity: 0.7
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    cx: 202.5,
    cy: 88.5,
    r: 1.5,
    fill: "#F3F6F9",
    fillOpacity: 0.7
  })), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    cx: 202.5,
    cy: 92.5,
    r: 1.5,
    fill: "#F3F6F9",
    fillOpacity: 0.7
  })), _circle17 || (_circle17 = /*#__PURE__*/React.createElement("circle", {
    cx: 198.5,
    cy: 88.5,
    r: 1.5,
    fill: "#F3F6F9",
    fillOpacity: 0.7
  })), _circle18 || (_circle18 = /*#__PURE__*/React.createElement("circle", {
    cx: 198.5,
    cy: 92.5,
    r: 1.5,
    fill: "#F3F6F9",
    fillOpacity: 0.7
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 105,
    width: 193,
    height: 23,
    rx: 2,
    fill: "#718095",
    fillOpacity: 0.49
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M103.648 114.201H25.3395C23.0851 114.201 23 115.167 23 116.357C23 117.548 23.0851 118.514 25.3395 118.514H103.648C105.903 118.514 106 117.548 106 116.357C106 115.167 105.903 114.201 103.648 114.201Z",
    fill: "#F3F6F9",
    fillOpacity: 0.7
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M33.6883 121.102H23.3101C23.0113 121.102 23 122.131 23 123.402C23 124.672 23.0113 125.702 23.3101 125.702H33.6883C33.9871 125.702 34 124.672 34 123.402C34 122.131 33.9871 121.102 33.6883 121.102Z",
    fill: "#F3F6F9",
    fillOpacity: 0.7
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M68.6682 107.301H24.3248C23.0482 107.301 23 108.266 23 109.457C23 110.648 23.0482 111.613 24.3248 111.613H68.6682C69.9448 111.613 70 110.648 70 109.457C70 108.266 69.9448 107.301 68.6682 107.301Z",
    fill: "#F3F6F9",
    fillOpacity: 0.7
  })), _circle19 || (_circle19 = /*#__PURE__*/React.createElement("circle", {
    cx: 198.5,
    cy: 113.5,
    r: 1.5,
    fill: "#F3F6F9",
    fillOpacity: 0.7
  })), _circle20 || (_circle20 = /*#__PURE__*/React.createElement("circle", {
    cx: 202.5,
    cy: 113.5,
    r: 1.5,
    fill: "#F3F6F9",
    fillOpacity: 0.7
  })), _circle21 || (_circle21 = /*#__PURE__*/React.createElement("circle", {
    cx: 206.5,
    cy: 113.5,
    r: 1.5,
    fill: "#F3F6F9",
    fillOpacity: 0.7
  })), _circle22 || (_circle22 = /*#__PURE__*/React.createElement("circle", {
    cx: 206.5,
    cy: 117.5,
    r: 1.5,
    fill: "#F3F6F9",
    fillOpacity: 0.7
  })), _circle23 || (_circle23 = /*#__PURE__*/React.createElement("circle", {
    cx: 206.5,
    cy: 121.5,
    r: 1.5,
    fill: "#F3F6F9",
    fillOpacity: 0.7
  })), _circle24 || (_circle24 = /*#__PURE__*/React.createElement("circle", {
    cx: 202.5,
    cy: 117.5,
    r: 1.5,
    fill: "#F3F6F9",
    fillOpacity: 0.7
  })), _circle25 || (_circle25 = /*#__PURE__*/React.createElement("circle", {
    cx: 202.5,
    cy: 121.5,
    r: 1.5,
    fill: "#F3F6F9",
    fillOpacity: 0.7
  })), _circle26 || (_circle26 = /*#__PURE__*/React.createElement("circle", {
    cx: 198.5,
    cy: 117.5,
    r: 1.5,
    fill: "#F3F6F9",
    fillOpacity: 0.7
  })), _circle27 || (_circle27 = /*#__PURE__*/React.createElement("circle", {
    cx: 198.5,
    cy: 121.5,
    r: 1.5,
    fill: "#F3F6F9",
    fillOpacity: 0.7
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDragItems);
export default __webpack_public_path__ + "static/media/drag-items.7a0954d3e294b8fe2c5c185b701aa681.svg";
export { ForwardRef as ReactComponent };